import { Component, Input } from '@angular/core';
import { CatalogItem } from '../catalog.service';
import {CityService} from '../../city.service';

@Component({
  selector: 'recommend-slider',
  templateUrl: './recommend-slider.component.html',
  styleUrls: ['./recommend-slider.component.less']
})
export class RecommendSliderComponent {
  @Input() items: CatalogItem[];
  constructor(public cityService: CityService) {
  }
}
